var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard 98"),React.createElement("path",{"d":"M20,0H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4A4,4,0,0,0,20,0Zm2,20a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H20a2,2,0,0,1,2,2Z","key":1}),React.createElement("path",{"d":"M12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z","key":2}),React.createElement("circle",{"cx":"18.5","cy":"5.5","r":"1.5","key":3})]);
}

Instagram.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 24 24","x":"0px","y":"0px"};

module.exports = Instagram;

Instagram.default = Instagram;
